import request from '@/utils/request'

// 获取签署任务详情
export function getSignInfoPcAndH5(data) {
    return request({
        url: '/api/common/v1/open/getSignInfoPcAndH5',
        method: 'post',
        data,
        isToken:'false'
    })
}

// 提交签署信息
export function signPcAndH5(data) {
    return request({
        url: '/api/common/v1/open/signPcAndH5',
        method: 'post',
        data
    })
}

// 上传手写签名并校验有效性
export function checkHandwrite(data) {
    return request({
        url: '/api/common/v1/open/checkHandwrite',
        method: 'post',
        data
    })
}

// PC任务设置嵌入版-获取签署任务信息
export function getDraftInfo(data) {
    return request({
        url: '/api/common/v1/open/getDraftInfo',
        method: 'post',
        data
    })
}

// 保存签署任务草稿
export function saveDraft(data) {
    return request({
        url: '/api/common/v1/open/saveDraft',
        method: 'post',
        data
    })
}

// 自动登录
export function autoLogin(data) {
    return request({
        url: '/api/common/v1/open/autoLogin',
        method: 'post',
        data
    })
}

// 无token上传文件
export function uploadSignFile(data) {
    return request({
        url: '/api/common/v1/open/uploadSignFile',
        method: 'post',
        data
    })
}

export function getSignFileImgArrayApi(data) {
    return request({
        url: '/api/common/v1/open/getSignFileImgArray',
        method: 'post',
        data
    })
}

export function updateTaskStatus2Send(data) {
    return request({
        url: '/api/common/v1/open/updateTaskStatus2Send',
        method: 'post',
        data
    })
}


export function getTaskInfo(data) {
    return request({
        url: '/api/common/v1/open/getTaskInfo',
        method: 'post',
        data,
        isToken:'false'
    })
}

//测试接口 瞎写的
export function signProcessPosition(data) {
    return request({
        url: '/api/common/v1/open/getTaskInfo',
        method: 'post',
        data,
        isToken:'false'
    })
}
export function getAuthTokenByPin(data) {
    return request({
        url: '/api/common/v1/open/getTaskInfo',
        method: 'post',
        data,
        isToken:'false'
    })
}
export function getAuthTokenBySmsVerificationCode(data) {
    return request({
        url: '/api/common/v1/open/getTaskInfo',
        method: 'post',
        data,
        isToken:'false'
    })
}
